export const getTimezoneIdentifier = (key: string) => {
  return localStorage.getItem("timezoneIdentifier_" + key) || undefined;
};

export const setTimezoneIdentifier = (
  key: string,
  timezoneIdentifier: string,
) => {
  localStorage.setItem("timezoneIdentifier_" + key, timezoneIdentifier);
};
